import { Avatar as MuiAvatar, type AvatarProps as MuiAvatarProps } from '@mui/material';
import { Avatar as FplAvatar } from '@figma/fpl-components';
import { forwardRef } from 'react';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';

const MUI_DEFAULT_AVATAR_SIZE = 40;

export type AvatarProps = MuiAvatarProps & {
  'aria-label': string;
};

function getAvatarPixelSize({ sx }: Pick<AvatarProps, 'sx'>): number {
  const width =
    sx != null && typeof sx === 'object' && !Array.isArray(sx) ? (sx as { width?: unknown }).width : undefined;

  return typeof width === 'number' ? width : MUI_DEFAULT_AVATAR_SIZE;
}

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(function Avatar(props, ref) {
  const isFplMigrationEnabled = useFplMigrationFlag();

  if (isFplMigrationEnabled) {
    const { children, src, 'aria-label': ariaLabel } = props;
    return (
      <FplAvatar
        ref={ref}
        aria-label={ariaLabel}
        name={typeof children === 'string' ? children : undefined}
        src={src || undefined}
        size={getAvatarPixelSize(props)}
      />
    );
  }

  return <MuiAvatar ref={ref} {...props} />;
});
